<script setup lang="ts">
import { PropertyId } from "~/classes/entity"

const props = defineProps({
  fileId: null
})
const { isSelectedIn } = useSelection()
const { state: viewModeState, previewScale } = useViewMode()
const { fileIdAttr } = useGlobals()
const { getReactiveFile } = useCollectionView()

const reactiveFile = getReactiveFile(props.fileId, "collection-view")!

if (!reactiveFile)
  throw new Error("Must not instantiate CollectionDetailFile without a reactive file")

const file = reactiveFile.ref()

const properties = computed(
  () => viewModeState
    .value
    .current
    .show
    .filter(p => p.propertyId !== PropertyId.FILE_VIRTUAL_PREVIEW)
    .filter(p => file.value.hasProperty(p.propertyId)),
)
const previewWidth = computed(() => {
  const scale = previewScale.value
  const width = 2 ** (5 + 5 * scale)
  return width
})
</script>

<template>
  <div
    v-if="file"
    :[dataAttr(fileIdAttr)]="file.id"
    class="group detail-file"
  >
    <div
      class="detail-file-inner"
      :style="{
        width: px(previewWidth),
      }"
    >
      <file-thumbnail
        :file
        shadowed
        :selected="isSelectedIn(file.id, 'collection-view')"
        :container-width="previewWidth"
        :container-height="previewWidth"
      />
    </div>
    <div
      class="detail-file-properties"
    >
      <div
        v-for="({ propertyId, size, color }, i) in properties"
        :key="propertyId"
        class="detail-file-property"
      >
        <file-property-view
          :property-id
          :size
          :reactive-file
          :color
          :selected="isSelectedIn(file.id, 'collection-view')"
          text-alignment="left"
          multiline
          :max-lines="5"
        />
        <div v-if="i === 0" class="detail-file-decal">
          <file-decal :file :selected="isSelectedIn(file.id, 'collection-view')" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.detail-file
  @apply relative flex cursor-pointer gap-2 p-2
.detail-file-inner
  @apply aspect-square flex flex-none items-center justify-center
.detail-file-properties
  @apply min-w-0 flex flex-col justify-center gap-[#{$page-properties-gap-file}]
.detail-file-property
  @apply w-full flex items-center
</style>
